import { Component, Input } from '@angular/core'

export interface TagColors {
  iconColor: string
  backgroundColor: string
  textColor: string
}

@Component({
  selector: 'basin-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent {
  @Input() styleClass: string
  @Input() value: string
  @Input() icon: string
  @Input() iconPosition: 'left' | 'right' = 'left'
  @Input() theme: string
  @Input() iconColor: string = 'var(--primary-color-text-links)'
  @Input() backgroundColor: string = 'var(--primary-color-25)'
  @Input() textColor: string = 'var(--primary-color-text-links)'

  getThemeColors(): TagColors {
    switch (this.theme) {
      case 'yellow':
      case 'warning':
        return {
          iconColor: 'var(--warning-color-dark-text)',
          backgroundColor: 'var(--warning-color-25)',
          textColor: 'var(--warning-color-dark-text)',
        }
      case 'green':
      case 'success':
        return {
          iconColor: 'var(--success-color-text-links)',
          backgroundColor: 'var(--success-color-15)',
          textColor: 'var(--success-color-text-links)',
        }
      case 'blue':
      case 'info':
        return {
          iconColor: 'var(--info-color-text-links)',
          backgroundColor: 'var(--info-color-15)',
          textColor: 'var(--info-color-text-links)',
        }
      case 'orange':
      case 'primary':
        return {
          iconColor: 'var(--primary-color-text-links)',
          backgroundColor: 'var(--primary-color-25)',
          textColor: 'var(--primary-color-text-links)',
        }
      case 'red':
      case 'error':
        return {
          iconColor: 'var(--stantec-error-red-text-links)',
          backgroundColor: 'var(--stantec-error-red-50)',
          textColor: 'var(--stantec-error-red-text-links)',
        }
      case 'gray':
        return {
          iconColor: 'var(--stantec-true-white)',
          backgroundColor: 'var(--stantec-mid-gray)',
          textColor: 'var(--stantec-true-white)',
        }
      case 'inactive':
        return {
          iconColor: 'var(--stantec-light-gray)',
          backgroundColor: 'var(--stantec-lightest-gray)',
          textColor: 'var(--stantec-light-gray)',
        }
      default:
        return {
          iconColor: this.iconColor,
          backgroundColor: this.backgroundColor,
          textColor: this.textColor,
        }
    }
  }
}
